import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
export * from '@angular/core';
export * from './directives/ons-navigator';
export * from './directives/ons-tabbar';
export * from './directives/ons-switch';
export * from './directives/ons-range';
export * from './directives/ons-select';
export * from './directives/ons-input';
export * from './directives/ons-pull-hook';
export * from './directives/ons-lazy-repeat';
export * from './directives/ons-splitter';
export * from './ons/notification';
export * from './ons/platform';
export * from './ons/alert-dialog-factory';
export * from './ons/popover-factory';
export * from './ons/dialog-factory';
export * from './ons/modal-factory';
export * from './ons/params';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { OnsNavigator } from './directives/ons-navigator';
import { OnsTabbar, OnsTab } from './directives/ons-tabbar';
import { OnsSegment } from './directives/ons-segment';
import { OnsSwitch } from './directives/ons-switch';
import { OnsRange } from './directives/ons-range';
import { OnsSelect } from './directives/ons-select';
import { OnsInput } from './directives/ons-input';
import { OnsSearchInput } from './directives/ons-search-input';
import { OnsCheckbox } from './directives/ons-checkbox';
import { OnsRadio } from './directives/ons-radio';
import { OnsPullHook } from './directives/ons-pull-hook';
import { OnsLazyRepeat } from './directives/ons-lazy-repeat';
import { OnsSplitterSide, OnsSplitterContent } from './directives/ons-splitter';
import { AlertDialogFactory } from './ons/alert-dialog-factory';
import { PopoverFactory } from './ons/popover-factory';
import { DialogFactory } from './ons/dialog-factory';
import { ModalFactory } from './ons/modal-factory';
import { ComponentLoader } from './ons/component-loader';
var directives = [
    OnsNavigator,
    OnsTabbar,
    OnsTab,
    OnsSegment,
    OnsSwitch,
    OnsRange,
    OnsSelect,
    OnsInput,
    OnsSearchInput,
    OnsCheckbox,
    OnsRadio,
    OnsPullHook,
    OnsLazyRepeat,
    OnsSplitterSide,
    OnsSplitterContent
];
var OnsenModule = /** @class */ (function () {
    function OnsenModule() {
    }
OnsenModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: OnsenModule });
OnsenModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function OnsenModule_Factory(t) { return new (t || OnsenModule)(); }, providers: [
        AlertDialogFactory,
        PopoverFactory,
        DialogFactory,
        ModalFactory,
        ComponentLoader
    ], imports: [[BrowserModule, CommonModule],
        BrowserModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OnsenModule, { declarations: function () { return [OnsNavigator,
        OnsTabbar,
        OnsTab,
        OnsSegment,
        OnsSwitch,
        OnsRange,
        OnsSelect,
        OnsInput,
        OnsSearchInput,
        OnsCheckbox,
        OnsRadio,
        OnsPullHook,
        OnsLazyRepeat,
        OnsSplitterSide,
        OnsSplitterContent]; }, imports: function () { return [BrowserModule, CommonModule]; }, exports: function () { return [OnsNavigator,
        OnsTabbar,
        OnsTab,
        OnsSegment,
        OnsSwitch,
        OnsRange,
        OnsSelect,
        OnsInput,
        OnsSearchInput,
        OnsCheckbox,
        OnsRadio,
        OnsPullHook,
        OnsLazyRepeat,
        OnsSplitterSide,
        OnsSplitterContent,
        BrowserModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnsenModule, [{
        type: NgModule,
        args: [{
                imports: [BrowserModule, CommonModule],
                declarations: [directives],
                exports: [
                    directives,
                    BrowserModule
                ],
                providers: [
                    AlertDialogFactory,
                    PopoverFactory,
                    DialogFactory,
                    ModalFactory,
                    ComponentLoader
                ]
            }]
    }], function () { return []; }, null); })();
    return OnsenModule;
}());
export { OnsenModule };

export {OnsSegment} from './directives/ons-segment';
export {OnsSearchInput} from './directives/ons-search-input';
export {OnsCheckbox} from './directives/ons-checkbox';
export {OnsRadio} from './directives/ons-radio';
//# sourceMappingURL=ngx-onsenui.js.map